export default __webpack_public_path__ + "static/media/home-banner-01.f40ba07e.svg";